const state = {
  currentPage: 1,
  totalPages: null,
  pageSize: 25,
  totalCount: null,
};

const getters = {
  getCurrentPage: () => state.currentPage,
  getTotalPage: () => state.totalPages,
  getPageSize: () => state.pageSize,
  getTotalCount: () => state.totalCount,
};

const actions = {
  // reset pagination when a list is loaded or when we dismount a component
  resetPagination({ commit }) {
    commit("SET_TOTAL_PAGES", null);
    commit("SET_CURRENT_PAGE", 1);
    commit("SET_TOTAL_COUNT", null);
  },
};

const mutations = {
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_PAGE_SIZE(state, pageSize) {
    state.pageSize = pageSize;
  },
  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
  SET_TOTAL_COUNT(state, totalCount) {
    state.totalCount = totalCount;
  },
  NEXT(state) {
    if (state.currentPage < state.totalPages) {
      state.currentPage = state.currentPage + 1;
    }
  },
  PREVIOUS(state) {
    if (state.currentPage >= 2) {
      state.currentPage = state.currentPage - 1;
    }
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
